import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { apporteurs as ap, dfr } from './pilotageApi';

const STATUT_FILTERS = [
  { k: 'en_attente', l: 'À valider' },
  { k: 'valide', l: 'Validés' },
  { k: 'refuse', l: 'Refusés' },
  { k: '', l: 'Tous' },
];
const OVERLAY = { position: 'fixed', inset: 0, background: 'rgba(20,28,39,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 };
const CARD = { background: '#fff', borderRadius: 12, padding: 22, width: 'min(460px,100%)', maxHeight: '90vh', overflowY: 'auto' };
const KV = { display: 'flex', justifyContent: 'space-between', gap: 12, padding: '6px 0', borderBottom: '1px solid #EDF0F3', fontSize: 13 };

// Admin — Partenaires (Lot 6). Validation manuelle sur données SIRET certifiées.
export default function Partenaires() {
  const nav = useNavigate();
  const [statut, setStatut] = useState('en_attente');
  const [list, setList] = useState(null);
  const [err, setErr] = useState(null);
  const [flash, setFlash] = useState(null);
  const [busy, setBusy] = useState(false);
  const [detail, setDetail] = useState(null);

  const say = (m) => { setFlash(m); setTimeout(() => setFlash(null), 3000); };

  const load = useCallback(() => {
    ap.list(statut).then((d) => setList(d.partenaires))
      .catch((e) => { if (e.code === 401 || e.code === 403) nav('/connexion'); else setErr(e.message); });
  }, [statut, nav]);
  useEffect(() => { load(); }, [load]);

  async function run(fn, msg) {
    setBusy(true);
    try { await fn(); say(msg); setDetail(null); load(); }
    catch (e) { say(`⚠️ ${e.detail || e.message}`); }
    finally { setBusy(false); }
  }

  if (err) return <div className="wrap"><div className="nt ba">{err}</div></div>;

  return (
    <>
      <div className="top">
        <h1>Partenaires</h1>
        <span className="ctx mono">{list ? list.length : 0}</span>
        <div className="sp" />
      </div>
      <div className="wrap">
        {flash && <div className="nt ok" data-testid="flash">{flash}</div>}

        <div className="tb" data-testid="onglets-partenaires">
          {STATUT_FILTERS.map((s) => (
            <button key={s.k} className={`tab ${statut === s.k ? 'on' : ''}`} data-testid={`filtre-${s.k || 'tous'}`}
              onClick={() => setStatut(s.k)}>{s.l}</button>
          ))}
        </div>

        {!list ? <div className="load">Chargement…</div> : list.length === 0 ? (
          <div className="empty">Aucun partenaire ici.</div>
        ) : (
          <div className="bk" data-testid="bloc-partenaires">
            {list.map((p) => (
              <div key={p.id} className="rw" data-testid={`partenaire-${p.id}`}>
                <div className="gw">
                  <div className="t">
                    {p.raison_sociale || `${p.prenom} ${p.nom}`}
                    {p.metier ? <span className="bg bg-b" style={{ marginLeft: 8 }}>{p.metier}</span> : null}
                  </div>
                  <div className="m mono">SIRET {p.siret} · {p.email} · {p.telephone}</div>
                  <div className="m">{p.adresse}</div>
                </div>
                <div className="ac">
                  <span className={`bg ${p.statut === 'valide' ? 'bg-g' : p.statut === 'refuse' ? 'bg-r' : 'bg-a'}`}>{p.statut}</span>
                  <button className="btn btn-s" data-testid={`detail-${p.id}`} onClick={() => setDetail(p)}>Détails</button>
                  {p.statut === 'en_attente' && (
                    <>
                      <button className="btn btn-s btn-p" data-testid={`valider-${p.id}`} disabled={busy}
                        onClick={() => run(() => ap.valider(p.id), 'Partenaire validé — e-mail d\'activation envoyé.')}>Valider</button>
                      <button className="btn btn-s btn-r" data-testid={`refuser-${p.id}`} disabled={busy}
                        onClick={() => run(() => ap.refuser(p.id, ''), 'Candidature refusée.')}>Refuser</button>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {detail && (
        <div style={OVERLAY} data-testid="partenaire-detail" onClick={() => setDetail(null)}>
          <div style={CARD} onClick={(e) => e.stopPropagation()}>
            <h3>{detail.raison_sociale || `${detail.prenom} ${detail.nom}`}</h3>
            <p className="mono" style={{ fontSize: 13, color: 'var(--t2)' }}>SIRET {detail.siret}</p>
            <div style={KV}><span>Métier</span><b>{detail.metier || '—'}</b></div>
            <div style={KV}><span>Contact</span><b>{detail.prenom} {detail.nom}</b></div>
            <div style={KV}><span>Email</span><b>{detail.email}</b></div>
            <div style={KV}><span>Téléphone</span><b>{detail.telephone}</b></div>
            <div style={KV}><span>Adresse</span><b style={{ textAlign: 'right' }}>{detail.adresse || '—'}</b></div>
            <div style={KV}><span>IBAN</span><b className="mono">{detail.rib?.iban || '—'}</b></div>
            <div style={KV}><span>BIC</span><b className="mono">{detail.rib?.bic || '—'}</b></div>
            <div style={KV}><span>Titulaire</span><b>{detail.rib?.titulaire || '—'}</b></div>
            <div style={KV}><span>Candidature</span><b>{dfr(detail.created_at)}</b></div>
            <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
              {detail.statut === 'en_attente' && (
                <button className="btn btn-p" disabled={busy}
                  onClick={() => run(() => ap.valider(detail.id), 'Partenaire validé — e-mail d\'activation envoyé.')}>Valider</button>
              )}
              <button className="btn btn-s" onClick={() => setDetail(null)}>Fermer</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
